import {TemplateRef} from '@angular/core';

export class AddressError {

  public type = 'warning';
  public message: any = undefined;

  public get alertClass(): string {
    return 'alert-' + this.type;
  }

  public get isString(): boolean {
    return typeof this.message === 'string';
  }

  public get isTemplate(): boolean {
    return this.message instanceof TemplateRef;
  }

  constructor(message: any, type?: 'warning' | 'danger' | 'info') {
    this.message = message;

    if (type) {
      this.type = type;
    }
  }

}
